import { render, staticRenderFns } from "./Siscarga.vue?vue&type=template&id=2086ac41"
import script from "./Siscarga.vue?vue&type=script&lang=js"
export * from "./Siscarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports